import { render, staticRenderFns } from "./ShutterPanel.vue?vue&type=template&id=72ca1f44&"
import script from "./ShutterPanel.vue?vue&type=script&lang=js&"
export * from "./ShutterPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports